var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 81,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.174.835c8.481 0 15.388 2.383 20.719 7.15 5.412 4.685 8.118 10.905 8.118 18.66 0 7.674-2.706 13.935-8.118 18.781-5.331 4.767-12.238 7.15-20.72 7.15h-8.602V38.276h8.603c3.796 0 6.745-1.05 8.845-3.15 2.18-2.1 3.271-4.928 3.271-8.482 0-3.393-1.09-6.14-3.271-8.24-2.1-2.181-5.049-3.272-8.845-3.272H16.482v65.675H.125V.835h30.049z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.868 8.064C45.54 3.301 38.637.92 30.16.92H.125v14.262l18.53.024v.004h11.504c3.795 0 6.742 1.09 8.84 3.27 2.18 2.1 3.27 4.845 3.27 8.235 0 3.553-1.09 6.379-3.27 8.478-2.098 2.099-5.045 3.149-8.84 3.149h-8.598v14.29h8.598c8.478 0 15.38-2.382 20.71-7.145 5.409-4.844 8.113-11.101 8.113-18.772 0-7.75-2.704-13.967-8.114-18.65z",
    fill: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 29.568,
    y1: 0.835,
    x2: 29.568,
    y2: 80.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78EFD0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 29.554,
    y1: 0.919,
    x2: 29.554,
    y2: 52.631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.411,
    stopColor: "#ADF694"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.273895939f572a571ddacfa060db8408.svg";
export { ForwardRef as ReactComponent };